// Add the JavaScript for the toggle button
document.addEventListener('DOMContentLoaded', function() {
    const toggleButton = document.getElementById('toggleButton');
    const moreText = document.getElementById('moreText');

    if (toggleButton) {
    toggleButton.addEventListener('click', function() {
        // Toggle the display of the additional text
        if (moreText.style.display === 'none') {
        moreText.style.display = 'block';
        toggleButton.textContent = 'Skaityti mažiau';  // Change button text
        } else {
        moreText.style.display = 'none';
        toggleButton.textContent = 'Skaityti daugiau';  // Change button text back
        }
    });
    }
});

// cart page js
function ptwAfterWrapinLoadHook(){
      var priceElement = $('.ptw-price.money');   
      var priceText = priceElement.text();
      //priceText = priceText.replace(/[()]/g, '').replace('€', 'EUR ').trim();
      priceText = priceText.replace(/[()]/g, '').replace('.', ',').trim();
      priceElement.text(priceText);
}